import { CONSUMER_RESPONSE_METRIC_HEADERS } from "../../constants";

const ConsumerResponseSummaryTable = ({ metrics }) => {
  return (
    <div className="overflow-auto">
      <table className="table table-borderless ">
        <thead className="table-head">
          <tr>
            {CONSUMER_RESPONSE_METRIC_HEADERS.map((header) => (
              <th className="text-center font-12-px bold-6" key={header}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {metrics.map((item) => (
              <td className="text-center font-14-px bold-4" key={item.id}>
                {item.value}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ConsumerResponseSummaryTable;
